import {
  Image,
  Stack,
  Strong,
  Text,
  VStack,
  Box,
  useBreakpointValue,
  Button,
  HStack,
  IconButton,
} from "@chakra-ui/react";
import React, { useEffect, useState, useRef } from "react";
import logo from "../../Images/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { verifyEmail } from "../../Redux/Action/auth/verifyEmailAction";
import { logout } from "../../Redux/Action/auth/logoutAction";
import { useNavigate } from "react-router-dom";
import { useTheme } from "next-themes";
import { getLocalStorageItem } from "../../Utils/Helper.js";
import { OtpInput } from "./OtpInput";
import { CommonButton } from "../ui/CommonButton";
import { FiChevronLeft } from "react-icons/fi";
import { GoArrowLeft } from "react-icons/go";

export const VerifyEmail = () => {
  const { resolvedTheme } = useTheme();
  const [OTP, setOTP] = useState("");
  const [isTimerOn, setIsTimerOn] = useState(false);
  const [isInputDisabled, setIsInputDisabled] = useState(true);
  const [timeLeft, setTimeLeft] = useState(0);
  const [isFirstVisit, setIsFirstVisit] = useState(true);
  const timerRef = useRef(null);
  const whitelabelData = getLocalStorageItem("whitelabelData")
  const userData = useSelector((state) => state?.Login?.userData);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Responsive values
  const formPadding = useBreakpointValue({ base: "1.5rem", sm: "2rem", md: "3rem" });
  const formMaxWidth = useBreakpointValue({ base: "100%", sm: "450px", md: "500px" });

  const sendOTP = () => {
    setOTP("");
    setIsInputDisabled(false);
    setIsTimerOn(true);
    setTimeLeft(120);
    const payload = {
      type: 'requestOTP',
    }
    dispatch(
      verifyEmail({
        payload,
        route: "VE",
        callback: (data) => {
        },
      })
    );

    if (timerRef.current) {
      clearInterval(timerRef.current);
    }

    timerRef.current = setInterval(() => {
      setTimeLeft((prev) => {
        if (prev <= 1) {
          clearInterval(timerRef.current);
          setIsTimerOn(false);
          setIsInputDisabled(true);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleSubmit = () => {
    if (OTP.length === 6) {
      setIsInputDisabled(true);
      const payload = {
        type: 'submitOTP',
        OTP: OTP,
      }
      dispatch(
        verifyEmail({
          payload,
          route: "VE",
          callback: (data) => {
            if (data?.meta?.code === 200) {
              navigate("/");
            } else {
              setIsInputDisabled(false)
            }
          },
        })
      );
    }
  };

  const formatTime = (seconds) => {
    const m = Math.floor(seconds / 60);
    const s = seconds % 60;
    return `${m}:${s < 10 ? "0" + s : s}`;
  };

  // Automatically send OTP when component mounts only on first visit
  useEffect(() => {
    if (isFirstVisit) {
      sendOTP();
      setIsFirstVisit(false);
    }
  }, [isFirstVisit]);

  useEffect(() => {
    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, []);
  const loading = useSelector((state) => state?.GetWhitelabel?.loading);
  const [logoSrc, setLogoSrc] = useState(null);


  useEffect(() => {
    if (!loading) {
      const selectedLogo =
        whitelabelData && resolvedTheme === "dark"
          ? whitelabelData.logo_dark
          : whitelabelData?.logo_light;

      setLogoSrc(selectedLogo || logo);
    }
  }, [loading, resolvedTheme]);

  const handleBackToSignup = () => {
    // Dispatch logout action to clear user state
    dispatch(logout({}));
    // Navigate back to signup page
    navigate("/signup");
  };

  return (
    <Stack
      gap="4"
      align="center"
      maxW={formMaxWidth}
      width="100%"
      margin="auto"
      borderRadius="10px"
      padding={formPadding}
      boxShadow={
        resolvedTheme === "dark"
          ? "var(--themeColor) 0px 2px 8px 0px"
          : "rgba(99, 99, 99, 0.2) 0px 2px 8px 0px"
      }
      mb={8} // Add bottom margin
      position="relative"
    >
      <IconButton
        aria-label="Back to Signup"
        position="absolute"
        top="10px"
        left="10px"
        variant="ghost"
        size="sm"
        onClick={handleBackToSignup}
        css={{
          _icon: {
            width: '5',
            height: '5',
          },
        }}
      >
        <GoArrowLeft />
      </IconButton>
      <Image src={logoSrc} alt="Logo" maxW="120px" mb={2} maxWidth="100%" />
      <VStack fontSize="sm" textAlign="center">
        Enter OTP received on your email: <br />
        <Strong>{userData?.email}</Strong>
      </VStack>

      <OtpInput 
        value={OTP} 
        onChange={setOTP} 
        isDisabled={isInputDisabled} 
      />

      <Box minH="1.5rem" textAlign="center" width="100%">
        {isTimerOn ? (
          <Text fontSize="sm" color="gray.500">
            Not received yet! You can resend it in{" "}
            <Text as="span" color="blue.500" fontWeight="medium" fontSize="md">
              {formatTime(timeLeft)}
            </Text>
          </Text>
        ) : (
          <CommonButton
            text="Re-send OTP"
            onClick={sendOTP}
            width="100%"
            variant="gradient"
          />
        )}
      </Box>

      {/* Back to Signup button moved to top left corner */}

      <CommonButton
        text="Submit"
        onClick={handleSubmit}
        disabled={OTP.length !== 6 || isInputDisabled}
        width="100%"
        variant={OTP.length === 6 && !isInputDisabled ? 'gradient' : 'default'}
      />
    </Stack>
  );
};